<template>
    <v-btn
        v-bind="$attrs" 
        v-on="$listeners"
        @click="emit('clicked', $event)" 
        text
        :color="color"
        :small="small"
    >
        <slot name="icon-left"></slot>
        {{ label }}
        <slot name="icon-right"></slot>
    </v-btn>
</template>

<script setup>

import { defineEmits, defineProps } from 'vue'

const emit = defineEmits(['clicked'])

const props = defineProps({
    label: { type: String, required: true },
    color: { type: String, default: 'primary' },
    small: { type: Boolean, default: false },
})

</script>